var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivacySettingsmssgnoti(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6673 10.835C16.6673 15.0017 13.7507 17.085 10.284 18.2933C10.1025 18.3549 9.90527 18.3519 9.72565 18.285C6.25065 17.085 3.33398 15.0017 3.33398 10.835V5.00168C3.33398 4.78066 3.42178 4.5687 3.57806 4.41242C3.73434 4.25614 3.9463 4.16834 4.16732 4.16834C5.83398 4.16834 7.91732 3.16834 9.36732 1.90168C9.54386 1.75084 9.76845 1.66797 10.0007 1.66797C10.2329 1.66797 10.4574 1.75084 10.634 1.90168C12.0923 3.17668 14.1673 4.16834 15.834 4.16834C16.055 4.16834 16.267 4.25614 16.4232 4.41242C16.5795 4.5687 16.6673 4.78066 16.6673 5.00168V10.835Z",
    stroke: "#4B5563",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacySettingsmssgnoti);
export default __webpack_public_path__ + "static/media/Privacy Settings mssg noti.65c2439ed2e83403ea7189555b612e38.svg";
export { ForwardRef as ReactComponent };